import React from 'react';
import { CoveoHeadless } from '@arm/ce-shared-components';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import config from '../../../temp/config';
import StarsRating from '../../SharedComponents/StarsRating';
import FeatureAnnouncementPanel from '../../SharedComponents/FeatureAnnouncementPanel';
import RenderingStyling from '../../../lib/RenderingStyling';
import { UseGlobalState } from '../../../context';
import { getAuthCoveoUser } from '../../../utils/authAccessToken';
import './SecurityCenter.css';

const SecurityCenterContainer = ({ rendering, sitecoreContext }) => {
  const { user } = UseGlobalState();

  // Access titles from rendering fields
  const header1Text = rendering?.fields?.Header1Title?.value || '';
  const header2Text = rendering?.fields?.Header2Title?.value || '';
  const header3Text = rendering?.fields?.Header3Title?.value || '';

  return (
    <div className="security-center-container" {...RenderingStyling(rendering.componentName)}>
      <CoveoHeadless
        CoveoOrganizationID={`${config.REACT_APP_COVEOORGANIZATIONID}`}
        CoveoGetTokenURI={`${config.REACT_APP_COVEOGETSEARCHTOKENURL}`}
        CoveoSearchHub={`${config.REACT_APP_SECURITYCENTERSEARCHHUB}`}
        CoveoQueryPipeline={`${config.REACT_APP_SECURITYCENTERQUERYPIPELINE}`}
        tabId={`${config.REACT_APP_COVEORESOURCESTABID}`}
        user={getAuthCoveoUser(user)}
        switchTagsLocation={true}
        showCountsInFacet={false}
        resultViewType="table"
        showRecommendedTag={true}
        showSmartSnippet={true}
        showAdvancedSearch={false}
        facetsConfig={[
          {
            title: 'Product Type',
            field: 'navigationhierarchiesprocessortype',
            isHierarchial: false,
            showCountsInFacet: false,
            enableFacetSearch: true,
          },
          {
            title: 'Document Type',
            field: 'navigationhierarchiescontenttype',
            isHierarchial: false,
            showCountsInFacet: false,
            enableFacetSearch: true,
          },
        ]}
        useUrlParams={true}
        tabDocumentSourceName={config.REACT_APP_COVEO_DOCUMENT_SOURCE}
        tabCommunitySourceName={config.REACT_APP_COVEO_COMMUNITY_SOURCE}
        tableOptions={{
          defaultSort: { field: 'published', order: 'desc' },
          itemsPerPage: 20,
          header1: header1Text,
          header2: header2Text,
          header3: header3Text,
        }}
        searchBoxTextPlaceholder={
          rendering?.fields?.SearchBoxTextPlaceholder?.value || 'Search security advisories'
        }
      >
        <StarsRating uid={rendering.uid} />
        <FeatureAnnouncementPanel fields={rendering?.fields} />
      </CoveoHeadless>
    </div>
  );
};

export default withSitecoreContext()(SecurityCenterContainer);
